import invariant from 'invariant'
import {useLocation, useNavigate} from 'react-router'

import {useAppSelector} from '../../hooks/redux'

import useGuard from '../../../../commons/src/hooks/use-guard'
import {goToPricings} from '../../services/navigation'
import {priceFormulaOptionsMap} from '../forms/pricings/utils'

import {Price, PriceFormula, PricingTab} from '../../types'

import chevronLeftIcon from '../../../../commons/src/assets/icons/chevron-left.svg'

import ActionBar from '../../../../commons/src/components/action-bar/ActionBar'
import Button from '../../../../commons/src/components/button'
import Headline from '../../../../commons/src/components/headline'
import Icon from '../../../../commons/src/components/icon'
import LinkButton from '../../../../commons/src/components/link-button'
import Tooltip from '../../../../commons/src/components/tooltip'
import TooltipHandler from '../../../../commons/src/components/tooltip-handler'
import Container from '../../components/container'
import PageContentLayout from '../../components/page-content-layout'
import PageHeader from '../../components/page-content-layout/PageHeader'

import PagePartial from '../page-partial'

import EditPricingFormPartial from './edit-pricing-form-partial'

const EditPricingPage = () => {
  const provider = useAppSelector(state => state.core.provider)
  invariant(provider, 'Provider is missing.')

  const navigate = useNavigate()
  const routerLocation = useLocation()
  const locationState = routerLocation.state as undefined | {pricings: Price[]}
  const pricings = locationState?.pricings || []

  useGuard(pricings.length > 0, () =>
    goToPricings(navigate, {activeTab: PricingTab.THREE_D_PRINTING})
  )

  const renderTooltip = () => (
    <TooltipHandler
      openOnClick
      tooltip={
        <Tooltip>
          {pricings.map((pricing, index) => (
            <div key={index}>{pricing.name}</div>
          ))}
        </Tooltip>
      }
    >
      <LinkButton>
        {pricings.length} pricing{pricings.length > 1 ? 's' : ''}
      </LinkButton>
    </TooltipHandler>
  )

  return (
    <PagePartial>
      <PageContentLayout
        header={
          <PageHeader
            headline={
              <ActionBar>
                <Button
                  hierarchy="secondary"
                  icon={<Icon source={chevronLeftIcon} />}
                  onClick={() =>
                    goToPricings(navigate, {
                      activeTab:
                        priceFormulaOptionsMap[pricings[0].formula || PriceFormula.THREE_D_PRINTING]
                          .tabKey,
                    })
                  }
                />
                <Headline
                  size="l"
                  label="Edit pricings"
                  addendum={renderTooltip()}
                  className="u-no-margin-bottom"
                />
              </ActionBar>
            }
          />
        }
      >
        <Container size="l">
          <EditPricingFormPartial
            pricings={pricings}
            provider={provider}
            onDone={() => {
              goToPricings(navigate, {
                activeTab:
                  priceFormulaOptionsMap[pricings[0].formula || PriceFormula.THREE_D_PRINTING]
                    .tabKey,
              })
            }}
          />
        </Container>
      </PageContentLayout>
    </PagePartial>
  )
}

export default EditPricingPage
